/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { WritableAtom, atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { Layout } from 'react-grid-layout';
import { addOrUpdateEntityItem, removeEntityId } from 'jotai/entity';
import { activeWorkspaceAtom } from 'jotai/workspace';
import { workspaceService } from 'services/workspace/WorkspaceService';

export const viewLayoutsIdsAtom = atom<string[], [string[]], void>(
  (get) => {
    const value = get(activeWorkspaceAtom).workspace.viewLayouts.allIds;
    return [...value];
  },
  (get, set, newValue: string[]) => {
    const previousWorkspace = get(activeWorkspaceAtom);
    previousWorkspace.workspace.viewLayouts.allIds = newValue;
    set(activeWorkspaceAtom, previousWorkspace);
  }
);

export interface ViewLayoutsAtomFamilyProps {
  viewLayouts: Layout[];
  isReset: boolean;
}

export const viewLayoutsAtomFamily = atomFamily<string, WritableAtom<Layout[], [ViewLayoutsAtomFamilyProps], void>>(
  (id: string) =>
    atom<Layout[], [ViewLayoutsAtomFamilyProps], void>(
      (get) => get(activeWorkspaceAtom).workspace.viewLayouts.byId[id],
      (get, set, viewLayoutProps: ViewLayoutsAtomFamilyProps) => {
        if (viewLayoutProps.isReset) {
          const previousWorkspace = get(activeWorkspaceAtom);
          removeEntityId(previousWorkspace.workspace.viewLayouts, id);
          set(activeWorkspaceAtom, { ...previousWorkspace });
        } else {
          const previousWorkspace = get(activeWorkspaceAtom);
          addOrUpdateEntityItem(previousWorkspace.workspace.viewLayouts, viewLayoutProps.viewLayouts, id);
          set(activeWorkspaceAtom, { ...previousWorkspace });
          workspaceService.updateWorkspace(previousWorkspace.workspace);
        }
      }
    )
);
